import React from "react";

export const OthersIcon = (): JSX.Element => {
    return (
        <svg width="24" height="19" viewBox="0 0 24 19" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path
                d="M21.75 0.75H1.75C1.19772 0.75 0.75 1.27233 0.75 1.91667V6.58333C0.75 7.22767 1.19772 7.75 1.75 7.75H21.75C22.3023 7.75 22.75 7.22767 22.75 6.58333V1.91667C22.75 1.27233 22.3023 0.75 21.75 0.75Z"
                stroke="#0156A6"
                strokeWidth="1.5"
            />
            <path
                d="M21.75 10.625H1.75C1.19772 10.625 0.75 11.1473 0.75 11.7917V16.4583C0.75 17.1027 1.19772 17.625 1.75 17.625H21.75C22.3023 17.625 22.75 17.1027 22.75 16.4583V11.7917C22.75 11.1473 22.3023 10.625 21.75 10.625Z"
                stroke="#0156A6"
                strokeWidth="1.5"
            />
            <path
                d="M18.7498 5.58752C19.4125 5.58752 19.9498 5.05025 19.9498 4.38751C19.9498 3.72477 19.4125 3.1875 18.7498 3.1875C18.0871 3.1875 17.5498 3.72477 17.5498 4.38751C17.5498 5.05025 18.0871 5.58752 18.7498 5.58752Z"
                fill="#0156A6"
            />
            <path
                d="M18.7498 15.5875C19.4125 15.5875 19.9498 15.0503 19.9498 14.3875C19.9498 13.7248 19.4125 13.1875 18.7498 13.1875C18.0871 13.1875 17.5498 13.7248 17.5498 14.3875C17.5498 15.0503 18.0871 15.5875 18.7498 15.5875Z"
                fill="#0156A6"
            />
        </svg>
    );
};
